var _classCallCheck = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var _ = require("lodash");

var BaseResource = require("./BaseResource");

var toQueryString = function toQueryString(obj) {
  return _.map(obj, function (v, k) {
    return encodeURIComponent(k) + "=" + encodeURIComponent(v);
  }).join("&");
};

var Integrations = /*#__PURE__*/function (_BaseResource) {
  "use strict";

  _inherits(Integrations, _BaseResource);

  var _super = _createSuper(Integrations);

  function Integrations(client) {
    var _this;

    _classCallCheck(this, Integrations);

    _this = _super.call(this, client);
    _this.path = "api/".concat(client.options && client.options.tenantId ? "".concat(client.options.tenantId, "/") : "", "integrations");
    return _this;
  }

  _createClass(Integrations, [{
    key: "details",
    value: function details() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._get("".concat(this.path, "/").concat(this.integratorId, "/").concat(this.accessToken).concat(params && params.length > 0 ? "?".concat(toQueryString(params)) : ""), options);
    }
  }, {
    key: "contentTypes",
    value: function contentTypes() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._get("".concat(this.path, "/getcontenttypes/").concat(this.integratorId, "/").concat(this.accessToken).concat(params && params.length > 0 ? "?".concat(toQueryString(params)) : ""), options);
    }
  }, {
    key: "allContent",
    value: function allContent() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._get("".concat(this.path, "/content/all/").concat(this.integratorId, "/").concat(this.accessToken).concat(params && params.length > 0 ? "?".concat(toQueryString(params)) : ""), options);
    }
  }, {
    key: "allContentFromContentType",
    value: function allContentFromContentType(contentType) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this._get("".concat(this.path, "/content/all/").concat(contentType, "/").concat(this.integratorId, "/").concat(this.accessToken).concat(params && params.length > 0 ? "?".concat(toQueryString(params)) : ""), options);
    }
  }, {
    key: "contentItem",
    value: function contentItem(contentID) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this._get("".concat(this.path, "/content/single/").concat(this.integratorId, "/").concat(this.accessToken, "/").concat(contentID).concat(params && params.length > 0 ? "?".concat(toQueryString(params)) : ""), options);
    }
  }, {
    key: "contentItemFromSlug",
    value: function contentItemFromSlug() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._get("".concat(this.path, "/content/slug/").concat(this.integratorId, "/").concat(this.accessToken, "/").concat(params && params.length > 0 ? "?".concat(toQueryString(params)) : ""), options);
    }
  }, {
    key: "smartFeedListAll",
    value: function smartFeedListAll() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._get("".concat(this.path, "/smartfeed/all/").concat(this.integratorId, "/").concat(this.accessToken, "/").concat(params && params.length > 0 ? "?".concat(toQueryString(params)) : ""), options);
    }
  }, {
    key: "smartFeedListAllXML",
    value: function smartFeedListAllXML() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._get("".concat(this.path, "/smartfeed/all-xml/").concat(this.integratorId, "/").concat(this.accessToken, "/").concat(params && params.length > 0 ? "?".concat(toQueryString(params)) : ""), options);
    }
  }, {
    key: "smartFeedListAllMap",
    value: function smartFeedListAllMap() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._get("".concat(this.path, "/smartfeed/all-map/").concat(this.integratorId, "/").concat(this.accessToken, "/").concat(params && params.length > 0 ? "?".concat(toQueryString(params)) : ""), options);
    }
  }, {
    key: "smartFeedItem",
    value: function smartFeedItem(itemID) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this._get("".concat(this.path, "/smartfeed/single/").concat(itemID, "/").concat(this.integratorId, "/").concat(this.accessToken, "/").concat(params && params.length > 0 ? "?".concat(toQueryString(params)) : ""), options);
    }
  }, {
    key: "websiteSitemap",
    value: function websiteSitemap() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._get("".concat(this.path, "/website/sitemap/").concat(this.integratorId, "/").concat(this.accessToken, "/").concat(params && params.length > 0 ? "?".concat(toQueryString(params)) : ""), options);
    }
  }, {
    key: "websiteNavigation",
    value: function websiteNavigation() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._get("".concat(this.path, "/website/navigation/").concat(this.integratorId, "/").concat(this.accessToken, "/").concat(params && params.length > 0 ? "?".concat(toQueryString(params)) : ""), options);
    }
  }, {
    key: "websiteNavigationFromParent",
    value: function websiteNavigationFromParent(parentID) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this._get("".concat(this.path, "/website/navigation/").concat(this.integratorId, "/").concat(this.accessToken, "/").concat(parentID).concat(params && params.length > 0 ? "?".concat(toQueryString(params)) : ""), options);
    }
  }, {
    key: "websiteJWT",
    value: function websiteJWT() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._get("".concat(this.path, "/website/jwt/").concat(this.integratorId, "/").concat(this.accessToken, "/").concat(params && params.length > 0 ? "?".concat(toQueryString(params)) : ""), options);
    }
  }, {
    key: "verifyHcapatcha",
    value: function verifyHcapatcha() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._post("".concat(this.path, "/website/verify-hcaptcha/").concat(this.integratorId, "/").concat(this.accessToken), data, options);
    }
  }, {
    key: "websiteContactForm",
    value: function websiteContactForm() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._get("".concat(this.path, "/website/contact-form/").concat(this.integratorId, "/").concat(this.accessToken, "/").concat(params && params.length > 0 ? "?".concat(toQueryString(params)) : ""), options);
    }
  }, {
    key: "websiteContactFormSubmit",
    value: function websiteContactFormSubmit() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._post("".concat(this.path, "/website/contact-form-submit/").concat(this.integratorId, "/").concat(this.accessToken), data, options);
    }
  }, {
    key: "websiteImageFormatting",
    value: function websiteImageFormatting(imagePath) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this._get("".concat(this.path, "/website/image-formatting/").concat(this.integratorId, "/").concat(this.accessToken, "/").concat(imagePath).concat(params && params.length > 0 ? "?".concat(toQueryString(params)) : ""), options);
    }
  }, {
    key: "smartFeedGetItemProxy",
    value: function smartFeedGetItemProxy(advertId) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this._get("".concat(this.path, "/website/proxy/getitem/").concat(this.integratorId, "/").concat(this.accessToken, "/").concat(advertId).concat(params && params.length > 0 ? "?".concat(toQueryString(params)) : ""), options);
    }
  }, {
    key: "retrieveIP",
    value: function retrieveIP() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._get("".concat(this.path, "/website/extras/retrieve-ip/").concat(this.integratorId, "/").concat(this.accessToken, "/").concat(params && params.length > 0 ? "?".concat(toQueryString(params)) : ""), options);
    }
  }, {
    key: "retrieveLocation",
    value: function retrieveLocation() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._get("".concat(this.path, "/website/extras/retrieve-location/").concat(this.integratorId, "/").concat(this.accessToken, "/").concat(params && params.length > 0 ? "?".concat(toQueryString(params)) : ""), options);
    }
  }, {
    key: "geocodingExact",
    value: function geocodingExact() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._get("".concat(this.path, "/website/extras/geocoding-exact/").concat(this.integratorId, "/").concat(this.accessToken, "/").concat(params && params.length > 0 ? "?".concat(toQueryString(params)) : ""), options);
    }
  }, {
    key: "geocodingAutocomplete",
    value: function geocodingAutocomplete() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._get("".concat(this.path, "/website/extras/geocoding-autocomplete/").concat(this.integratorId, "/").concat(this.accessToken, "/").concat(params && params.length > 0 ? "?".concat(toQueryString(params)) : ""), options);
    }
  }, {
    key: "weducSettings",
    value: function weducSettings(weducsettingsid) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this._get("".concat(this.path, "/website/weduc/settings/").concat(this.integratorId, "/").concat(this.accessToken, "/").concat(weducsettingsid).concat(params && params.length > 0 ? "?".concat(toQueryString(params)) : ""), options);
    }
  }]);

  return Integrations;
}(BaseResource);

module.exports = Integrations;